import {Parser} from "./AbstractParser";

export class CurrencyParser extends Parser {
    parse() {
        if(this.input === undefined || this.input === null) {
            return "R$ 0,00";
        }
        const arrStr = this.input.toLocaleString("ar-EG").split(".");
        let decimals = arrStr[1] === undefined ? "00" : arrStr[1];
        decimals = decimals.length == 1 ? decimals + "0" : decimals;
        return "R$ " + arrStr[0].replace(/,/g, ".") + "," + decimals;
    }
}


// WEBPACK FOOTER //
// ./src/parser/CurrencyParser.js